import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PrefetchLinkDirective, TooltipDirective } from '@kaseya-design-components';
import { HelpMenuComponent } from '@layout/help-menu/components/help-menu/help-menu.component';
import { NotificationsComponent } from '@layout/notifications/components/notifications/notifications.component';
import { ProfileMenuComponent } from '@layout/profile-menu/components/profile-menu/profile-menu.component';
import { LauncherComponent } from '@layout/launcher/components/launcher/launcher.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Permission } from '@core/permissions/models/permission.enum';
import { TopNavigationComponent } from '@layout/navigation/components/top-navigation/top-navigation.component';
import { PermissionDirective } from '@core/permissions/directives/permission.directive';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { NavigationFacade } from '@core/navigation/facades/navigation.facade';

import { NavigationMenuComponent } from '@layout/navigation/components/navigation-menu/navigation-menu.component';
import { HeaderUtilitiesMenuComponent } from '@layout/header/components/header-utilities-menu/header-utilities-menu.component';
import { HeaderActionItemId } from '@layout/header/models/header-action-item-id.enum';
import { adminSettingsViewPermissionsList } from '@core/permissions/constants/permissions.const';

@Component({
  selector: 'itc-header',
  templateUrl: 'header.component.html',
  styleUrl: 'header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    PrefetchLinkDirective,
    HelpMenuComponent,
    NotificationsComponent,
    ProfileMenuComponent,
    LauncherComponent,
    TranslatePipe,
    PermissionDirective,
    TopNavigationComponent,
    NavigationMenuComponent,
    HeaderUtilitiesMenuComponent,
    RouterLinkActive,
    TooltipDirective,
  ],
})
export class HeaderComponent {
  private readonly navigationFacade = inject(NavigationFacade);

  readonly TopNavigationPath = TopNavigationPath;
  readonly Permission = Permission;
  readonly HeaderActionItemId = HeaderActionItemId;
  readonly adminSettingsViewPermissionsList = adminSettingsViewPermissionsList;

  setActiveTopNavigation(topNavigation: TopNavigationPath, isActive: boolean): void {
    if (isActive && this.navigationFacade.activeTopNavigation() !== topNavigation) {
      this.navigationFacade.setActiveTopNavigation(topNavigation);
    }
  }
}
